import { GenericActionBlockCombinedProps } from './types';

const usePresenter = (props: GenericActionBlockCombinedProps): GenericActionBlockCombinedProps => {
  return props;
};

export default usePresenter;
